// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__1_a0L","img":"Carousel_img__31Vto"};